export default function SelectedFilePreview({ fileType, url }) {
  if (!url) return null; // No URL to preview

  return (
    <div className="preview mt-3 text-center">
      {fileType === "image" ? (
        <img src={url} alt="Upload preview" width="200" />
      ) : fileType === "video" ? (
        <video controls style={{ maxWidth: "100%" }} src={url}>
          Your browser does not support the video tag.
        </video>
      ) : (
        <p>Unsupported file format</p>
      )}
    </div>
  );
}
